import React from 'react';

const CrayonSvg = ({width = 20, height = 20, couleur = "#002335"}) => (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.11837 13.1279L14.7162 1.53009C14.735 1.52442 14.7556 1.51852 14.7777 1.51253C14.9366 1.46948 15.1659 1.42467 15.4349 1.42096C15.9531 1.41381 16.6406 1.55486 17.3159 2.23014C17.9912 2.90543 18.1323 3.59298 18.1251 4.11115C18.1214 4.3802 18.0766 4.60948 18.0335 4.7684C18.0276 4.7905 18.0217 4.81104 18.016 4.82992L6.4182 16.4277L2.6684 16.8777L3.11837 13.1279Z"
            stroke={couleur} strokeWidth="2"/>
        <path d="M11.8896 2.94336L16.3792 7.43293" stroke={couleur} strokeWidth="2"/>
    </svg>
);

export default CrayonSvg;
